import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import TimeFormat from '@scripts/utilities/time-format.js';

import Analytics from '../Analytics/index.jsx';
import ArticleList from '../ArticleList/index.jsx';
import ArticleMetadata from '../ArticleMetadata/index.jsx';
import ArticleReaction from '../ArticleReaction/index.jsx';
import CMSContent from '../CMSContent/index.jsx';
import LoadMore from '../LoadMore/index.jsx';
import LockScreen from '../LockScreen/index.jsx';
import SearchField from '../Search/index.jsx';
import Spinner from '../Spinner/index.jsx';


class DailySnapshotArticle extends React.Component {
  constructor(props) {
    super(props)
    this.sendAnalytics = this.sendAnalytics.bind(this);
  }

  sendAnalytics(isVisible) {
    if (isVisible) {
      CSAnalytics("Content Summary Seen", this.props.article.analytics)
    }
  }
  
  render() {
    var article = this.props.article;
    var reactions;
    var content;

    if (article.locked) {
      content = (
        <div className="cs-daily-snapshot-article__content">
          <LockScreen {...article} />
        </div>
      );
    } else {
      if (article.reactions) {
        reactions = (
          <div className="cs-daily-snapshot-article__reactions">
            <ArticleReaction
              onReactionUpdate={(data)=>{this.props.onReactionUpdate(article, 'reaction', data)}}
              article={article}
            />
          </div>
        );
      }

      content = (
        <React.Fragment>
          <div className="cs-daily-snapshot-article__content">
            <h2 className="cs-daily-snapshot-article__date-title">
              {TimeFormat(article.timestamp)}
            </h2>
            <Analytics.All eventProperties={article.analytics}>
              <CMSContent content={article.content} />
            </Analytics.All>
          </div>
          {reactions}
        </React.Fragment>
      );
    }


    return (
      <VisibilitySensor
        partialVisibility={true}
        onChange={this.sendAnalytics}
        offset={{bottom:300, top:300}}
      >
        <div className="cs-daily-snapshot-article">
          <div className="cs-daily-snapshot-article__meta">
            <ArticleMetadata article={article} typeHidden/>
          </div>
          {content}
        </div>
      </VisibilitySensor>
    );
  }
}


class DailySnapshotList extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      fetching: false,
      articles: [],
      error: undefined,
      query: '',
      hasData: false,
      canPage: true
    };

    this.fetchComplete = this.fetchComplete.bind(this);
    this.fetchError = this.fetchError.bind(this);
    this.fetchPage = this.fetchPage.bind(this);
    this.handleArticleUpdate = this.handleArticleUpdate.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
  }

  /**
   * retrieve the first 'page' of articles.
   */
  componentDidMount() {
    this.fetchPage();
  }

  fetchPage() {
    if (! this.state.fetching) {
      this.setState({ fetching: true, canPage: true });
      this.props.dailySnapshotService.fetchPage(this.state.page, this.state.query)
        .then(this.fetchComplete)
        .catch(this.fetchError);
    }
  }

  fetchComplete(response) {
    this.setState(function(oldState) {
      const articlesToAdd = response?.articles || response;
      const newArticles = oldState.articles.concat(articlesToAdd);
      const totalArticlesCount = response?.count || 0;

      return {
        articles: newArticles,
        canPage: articlesToAdd.length > 0,
        hasData: totalArticlesCount === 0 ? true : newArticles.length < totalArticlesCount,
        page: (oldState.page + 1),
        fetching: false
      };
    });
  }

  fetchError(error) {
    this.setState({ error: error, fetching: false });
  }

  nextPage() {
    if ((! this.state.fetching) && this.state.canPage) {
      this.fetchPage()
    }
  }

  handleArticleUpdate(article, type, data) {
    switch(type)
    {
      case 'reaction':
        this.setState({
          articles: this.state.articles.map(item => {
            if (item.id === article.id)
              return {...item, reactions: data.value}
            else
              return item;
          })
        })
      break;
    }
  }

  handleSearchChange(value) {
    if (this.state.query === value.trim()) return;
    if (value.trim().length < 3) return;
    this.setState({
      fetching: false,
      page: 1,
      articles: [],
      query: value.trim()
    }, this.fetchPage);
  }

  render() {
    var search;
    var articles;
    var loadMore;

    search = (
      <SearchField
        isBusy={this.state.fetching}
        onChange={this.handleSearchChange}
        placeholder="Search Daily Snapshots"
      />
    );

    if ((! this.state.articles.length) && this.state.fetching) {
      articles = (
        <div className="my-4">
          <Spinner />
        </div>
      );
    } else {
      var innerContent = [];

      if (this.state.articles.length) {
        for (var i = 0; i < this.state.articles.length; i++) {
          var article = this.state.articles[i];

          innerContent.push(
            <ArticleList.Item key={article.id}>
              <DailySnapshotArticle article={article} onReactionUpdate={this.handleArticleUpdate} />
            </ArticleList.Item>
          );
        }
      } else {
        innerContent.push(
          <ArticleList.Empty key="empty" />
        );
      }

      articles = (
        <ArticleList>
          {innerContent}
        </ArticleList>
      );
    }

    // display the load more button, but only once we've retrieved at least a
    // single page of articles.
    if (this.state.articles.length) {
      if (this.state.canPage) {
        if (this.state.hasData) {
          loadMore = (
            <LoadMore
              onClick={this.nextPage}
              fetching={this.state.fetching}
            />
          );
        }
      }
    }

    return (
      <React.Fragment>
        {search}
        {articles}
        {loadMore}
      </React.Fragment>
    );
  }
}

export default DailySnapshotList;

